export enum ChannelTypes {
	Email,
	// SMS,
	// Slack,
}
